function useNameMenuStore() {
  const nameMenu = useState('nameMenu', () => '')

  function setNameMenuNVEAR(term) {
    nameMenu.value = term
  }

  return { nameMenu, setNameMenuNVEAR }
}

export default useNameMenuStore